import React, { useContext, useEffect, useMemo, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { Button } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';
import Modal from '../Modal';
import '../../css/ViewNotificationModal.less';
import '../../css/SystemNotificationCard.less';

const ViewNotificationModal = observer((props) => {
  const { notificationManager } = useContext(MobXProviderContext);
  const { open, close, t } = props;
  const ModalBanner = useMemo(() => SatCoreComponent('ModalBanner'), []);
  const SystemNotificationCard = SatCoreComponent('SystemNotificationCard');
  const [thisModalTitle, setThisModalTitle] = useState(t('exportReady', 'Export Ready'));
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const { systemNotification } = notificationManager;
    if (!systemNotification) {
      setIsError(true);
      setThisModalTitle(t('exportMsg', 'Export Message'));
    }
  }, []);

  return (
    <Modal
      className='view-notification-modal'
      closeOnDimmerClick={false}
      closeOnEscape={true}
      onClose={close}
      open={open}>
      <ModalBanner onClose={close} title={thisModalTitle} />
      <Modal.Content>
        {(!isError) ? (
          <SystemNotificationCard
            key='linked-notification'
            handleDeleteSystemNotification={null}
            notification={notificationManager.systemNotification}
            showDelete={false} />
        )
          : (
            <div className='error-msg'>
              <p>{t('notificationErrorMsg', 'There was a problem retrieving the linked notification')} </p>
            </div>
          )}
      </Modal.Content>
      <Modal.Actions>
        <Button basic className='cancelButton' onClick={close} primary>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
});

export default ViewNotificationModal;

SatCoreRegister('ViewNotificationModal', ViewNotificationModal);
